<template>
    <div>
      <section>
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-text-field
            v-model="filtros.transaction_id"
            label="Folio"
            outlined
            placeholder="INTRODUZCA Folio"
            @keyup.enter="buscartransaction_id(filtros.transaction_id)"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md2>
          <v-btn
            color="primary"
            @click="buscartransaction_id"
            class="mt-2"
          >
            BUSCAR
          </v-btn>
        </v-flex>
      </v-layout>
  
      <v-layout row class="mt-4">
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="muestras"
                :items-per-page="15"
                :search="filtros.filtro"
                class="elevation-1 custom-header"
                :height="$vuetify.breakpoint.height * 0.65 + 'px'"
              >
                <template v-slot:item="props">
                  <tr>
                    <td class="text-center">{{ props.item.transaction_id }}</td>
                    <td class="text-center">
                      <a
                        v-if="props.item.PDF_Toma"
                        :href="props.item.PDF_Toma"
                        target="_blank"
                        class="text-decoration-none primary--text"
                      >
                        {{ props.item.Paciente }}
                      </a>
                      <span v-else>{{ props.item.Paciente }}</span>
                    </td>
                    <td class="text-center">{{ props.item.Causa }}</td>
                    <td class="text-center">
                      <span>{{ props.item.FechaSolicitud }}</span>
                    </td>
                    <td class="text-center">{{ props.item.FechaCita }}</td>
                    <td class="text-center">
                      <v-icon
                        v-if="!props.item.FechaMuestra"
                        color="primary"
                        class="calendar-icon"
                        @click="abrirModalFecha(props.item)"
                      >
                        mdi-calendar
                      </v-icon>
                      <a
                        v-else
                        href="#"
                        class="text-decoration-none primary--text"
                        @click.prevent="abrirModalFecha(props.item)"
                      >
                        {{ props.item.FechaMuestra }}
                      </a>
                    </td>
                  </tr>
                </template>
  
                <template v-slot:no-data>
                  No hay datos para mostrar
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </section>
  
    <v-dialog v-model="modalFecha" max-width="500px">
    <v-card>
      <v-card-title class="headline">Actualizar Fecha de Toma</v-card-title>
      <v-card-text>
        <v-date-picker v-model="fechaSeleccionada" full-width></v-date-picker>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="modalFecha = false">Cancelar</v-btn>
        <v-btn color="blue darken-1" text @click="guardarFecha">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
    </div>
  </template>
  
  <script>
  
  import ServicioRecepcionDAO from "../../services/recepciondao";
  
  export default {
    name: "recepcion-dao",
    data() {
      return {
        loading: false,
        modalFecha: false,
        fechaSeleccionada: null,
        muestraSeleccionada: null,
        fechaTipo: null,
        filtros: {
          transaction_id: "",
          filtro: ""
        },
        headers: [
          { text: "Folio", value: "transaction_id", align: "center" },
          { text: "Paciente", value: "Paciente", align: "center" },
          { text: "Motivo Prueba", value: "Causa", align: "center" },
          { text: "Fecha Solicitud", value: "FechaPago", align: "center" },
          { text: "Fecha Cita", value: "FechaToma", align: "center" },
          { text: "Fecha Toma", value: "FechaMuestra", align: "center" },
        ],
        muestras: [],
      };
    },
    methods: {
      /*
        async cargarReporte() {
        try {
          this.loading = true;
          const response = await ServicioRecepcionDAO.reporte();
          if (response?.data?.result === 1 && response?.data?.tables > 0 && Array.isArray(response?.data?.data?.Table0)) {
            this.muestras = response.data.data.Table0;
          } else {
            console.warn('La respuesta no contiene datos válidos');
            this.muestras = [];
          }
        } catch (error) {
          console.error('Error al cargar el reporte:', error);
          this.muestras = [];
        } finally {
          this.loading = false;
        }
      },
      */
      async verResultados(item) {
        window.open(this.config.RutaResultados + item.PDF, "_blank");
      },
      /*
      async enviarResultados(item) {
        try {
          this.loading = true;
          
          // Preparar los datos para enviar al servicio
          const datos = {
            id: item.id,
            transaction_id: item.transaction_id,
            Paciente: item.Paciente,
            PDF: item.PDF,
            Correo: item.Correo
          };
          
          // Llamar al servicio de envío de certificados
          const response = await ServicioCertificadoDAO.enviar(datos);
          
          if (response?.data?.result === 1) {
            // Actualizar el estado del item a ENVIADO
            item.EstatusDAO = 'ENVIADO';
            this.$root.mensajeExito = 'Resultados enviados correctamente por correo';
          } else {
            this.$root.mensajeError = 'Error al enviar los resultados: ' + (response?.data?.mensaje || 'Error desconocido');
          }
        } catch (error) {
          console.error('Error al enviar resultados:', error);
          this.$root.mensajeError = 'Error al enviar los resultados por correo';
        } finally {
          this.loading = false;
        }
      },
      */
      abrirModalFecha(item) {
        this.muestraSeleccionada = item;
        this.fechaSeleccionada = this.fechaPicker(this.$root.hoy);
        this.modalFecha = true;
        this.fechaTipo = 'Muestra';
      },
      async guardarFecha() {
        if (this.fechaSeleccionada && this.muestraSeleccionada) {
          try {
            const [year, month, day] = this.fechaSeleccionada.split('-');
            const fechaFormatoVista = `${day}/${month}/${year}`;
            const fechaFormatoSQL = `${year}-${month}-${day}`;

            const response = await ServicioRecepcionDAO.actualizarFechaMuestra({
              id: this.muestraSeleccionada.id,
              FechaMuestra: fechaFormatoSQL
            });

            if (response?.data?.result === 1) {
              this.muestraSeleccionada.FechaMuestra = fechaFormatoVista;
              this.$root.mensajeExito = 'Fecha de toma actualizada correctamente';
            } else {
              this.$root.mensajeError = 'Error al actualizar la fecha de toma';
              return;
            }
          } catch (error) {
            console.error('Error al actualizar fecha de toma:', error);
            this.$root.mensajeError = 'Error al actualizar la fecha de toma';
            return;
          } finally {
            this.modalFecha = false;
            this.fechaSeleccionada = null;
            this.muestraSeleccionada = null;
            this.fechaTipo = null;
          }
        }
      },
      async buscartransaction_id() {
        
        this.muestras = [];

        if (!this.filtros.transaction_id) {
          this.$root.mensajeError = 'Por favor ingrese un transaction_id para buscar.';
          return;
        }
    
        this.loading = true;
        try {
  
          const openPayResponse = await ServicioRecepcionDAO.consultarFolio({ transaction_id: this.filtros.transaction_id });
          
          if (openPayResponse.data.result === 1) {
           
  
            const registro = openPayResponse.data.data.Table0;
  
            // Validar si el transaction_id ya existe
            //const transaction_idExistente = this.muestras.some(muestra => muestra.transaction_id === registro[0].transaction_id);
            //if (transaction_idExistente) {
            if (registro[0].Resultado == "NO EXISTE") {
              this.$root.mensajeAviso = 'Folio pendiente de pago.';
              return;
            }

             // Add to the beginning of the array
             this.muestras.unshift(registro[0]);
  
             return;

          }
  
          if (openPayResponse.data.result === 2) {
            this.$root.mensajeAviso = 'Folio pendiente de pago.';
          }
  
          if (openPayResponse.data.result === 3) {
            this.$root.mensajeError = 'Error al procesar: ' + openPayResponse.data.mensaje;
          }
        } catch (openPayError) {
              this.$root.$emit('mostrarConfirmar', {
                titulo: 'Error',
                mensaje: 'Error al obtener información de OpenPay. Por favor intente nuevamente. ' + openPayError,
                resolve: () => {},
                reject: () => {}
              });
            }  
        }
    }
  };
  </script>
  
  <style scoped>
  .v-data-table ::v-deep th {
    background-color: #204871 !important;
    color: white !important;
    font-weight: bold;
    text-align: center !important;
  }

  .calendar-icon {
    cursor: pointer;
  }
</style>
  
  <style>
  .custom-header th {
    height: 48px !important;
    font-weight: bold;
  }
  </style>
